
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { stringStep } from '../../../concepts/commands/CommandWizard';
import { randomHat } from '../../canvas/participants/Hat';
import { toolEquip } from '../../canvas/tooling/ToolCommands';
import { ProfileModel } from '../../ProfileModel';
import { alert } from '../alerts/AlertCommands';
import { HatController } from './HatController';

export const userWearHat = defineCommand(
    'userWearHat',
    'User: Wear Hat...',
    (cc, [type]: [string?]) => {
        type = type ?? randomHat();
        const me = cc.call(ProfileModel);
        const ctrl = cc.call(HatController);
        ctrl.setUserHat(me.id, type);
    },
    [
        stringStep('hat', 'Which hat?'),
    ]
);

export const userRemoveHat = defineCommand(
    'userWearHat',
    'User: Remove Hat',
    cc => {
        const me = cc.call(ProfileModel);
        const ctrl = cc.call(HatController);
        ctrl.setUserHat(me.id, null);
    }
);

export const userStealHat = defineCommand(
    'userStealHat',
    null,
    (cc, [throwId]: [string?]) => {
        if (!throwId) return;
        const me = cc.call(ProfileModel);
        const ctrl = cc.call(HatController);
        const hatting = ctrl.getStore().getState();
        const [ownerId, data] = Object.entries(hatting)
            .find(([_, v]) => v[0] === 'throw' && v[3] === throwId) ?? [];
        if (!ownerId) return;
        ctrl.setUserHat(ownerId, null);
        ctrl.setUserHat(me.id, data[1]);
    },
);

export const userThrowHat = defineCommand(
    'userThrowHat',
    'User: Throw Hat',
    cc => {
        const dispatch = cc.call(CommandDispatcher);
        const me = cc.call(ProfileModel);
        const ctrl = cc.call(HatController);
        const hatting = ctrl.getStore().getState();
        const entry = hatting[me.id];

        if (entry && entry[0] === 'wear') {
            dispatch(toolEquip, ['throwHatTool']);
        }
        else {
            dispatch(alert, ['You\'re not wearing a hat!']);
        }
    }
);

export const inHatsCommands = () => inCommands(
    userWearHat,
    userStealHat,
    userThrowHat,
);

